module.exports = __webpack_public_path__ + "img/fos-journal.0359ad9f.png";